import { useCallback, useEffect } from 'react'
// eslint-disable-next-line camelcase -- Expected
import { unstable_usePrompt } from 'react-router-dom'

export function usePrompt(message: string, when = true) {
	const blockerFunction = useCallback(
		({ currentLocation, nextLocation }) => {
			const isSamePath = nextLocation.pathname === currentLocation.pathname
			// Block only if it's a significant path change and not just query changes
			return when && !isSamePath
		},
		[when]
	)

	unstable_usePrompt({ message, when: blockerFunction })

	const warnWhenListener = useCallback(
		(e: { preventDefault: () => void; returnValue: string }) => {
			e.preventDefault()

			e.returnValue = message

			return e.returnValue
		},
		[message]
	)

	useEffect(() => {
		if (when) {
			window.addEventListener('beforeunload', warnWhenListener)
		}

		return () => {
			window.removeEventListener('beforeunload', warnWhenListener)
		}
	}, [warnWhenListener, when])
}
